var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire93b0"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire93b0"] = parcelRequire;
}
parcelRequire("4MtUR");
function $0ce5141a586bd8d5$export$f0a4cb52e779eda4(href) {
    // avoid duplicates
    for(let i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].href === href) return Promise.resolve();
    }
    return new Promise((resolve, reject)=>{
        const link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = href;
        link.onload = resolve;
        link.onerror = reject;
        document.head.appendChild(link);
    });
}
function $0ce5141a586bd8d5$export$4b938d075d59879c(tag, rawProps) {
    const el = document.createElement(tag);
    const { children: children, ...otherProps } = rawProps;
    const props = otherProps;
    for(const key in props){
        if (key === "style") for(const key2 in props.style)el.style[key2] = props.style[key2];
        else if (typeof props[key] === "function" && key[0] === "o" && key[1] === "n") el.addEventListener(key.substr(2), props[key]);
        else el[key] = props[key];
    }
    function addChild(child) {
        if (child instanceof Array) child.forEach(addChild);
        else if (child instanceof Node) el.appendChild(child);
        else if (child) el.appendChild(document.createTextNode(String(child)));
    }
    if (children) addChild(children);
    return el;
}
function $0ce5141a586bd8d5$export$4a80062ca50b57c7(el, className, enabled) {
    const regexp = new RegExp("\\s*" + className, "g");
    if (typeof enabled === "undefined") enabled = !regexp.test(el.className);
    else if (enabled && regexp.test(el.className)) return;
    if (enabled) el.className += " " + className;
    else el.className = el.className.replace(regexp, "");
}




const $7d9f01ff152f00eb$export$f3c6ed4330abfc18 = function() {
    return "#" + ("00000" + Math.floor(Math.random() * 16777216).toString(16)).slice(-6);
};
const $7d9f01ff152f00eb$export$5b36b6f0d685d40 = function(v) {
    var i = Math.floor(v * 6);
    var f = (v * 6 - i + 1) % 1;
    var q = ("0" + Math.round(255 * (1 - f)).toString(16)).slice(-2);
    var t = ("0" + Math.round(255 * f).toString(16)).slice(-2);
    switch((i + 6) % 6){
        case 0:
            return "#FF" + t + "00";
        case 1:
            return "#" + q + "FF00";
        case 2:
            return "#00FF" + t;
        case 3:
            return "#00" + q + "FF";
        case 4:
            return "#" + t + "00FF";
        case 5:
            return "#FF00" + q;
    }
};
const $7d9f01ff152f00eb$export$e54c95be12cf2344 = function(r, g, b) {
    return "#" + ("0" + Math.floor(r).toString(16)).slice(-2) + ("0" + Math.floor(g).toString(16)).slice(-2) + ("0" + Math.floor(b).toString(16)).slice(-2);
};



class $c2d7541b81dd5a64$export$2e2bcd8739ae039 {
    constructor(){
        this._listeners = {};
        this._queued = {};
        this._timeout = null;
    }
    on(type, callback) {
        let registered = this._listeners[type];
        if (!registered) {
            registered = [];
            this._listeners[type] = registered;
        }
        registered.push(callback);
    }
    emit(type, arg) {
        const registered = this._listeners[type];
        if (registered) registered.forEach((cb)=>cb.call(this, arg));
    }
    emitOnceAsync(type, arg) {
        this._queued[type] = arg;
        if (!this._timeout) this._timeout = setTimeout(()=>{
            this._timeout = null;
            const queued = this._queued;
            this._queued = {};
            for(const type in queued)this.emit(type, queued[type]);
        }, 0);
    }
    removeListener(type, callback) {
        const registered = this._listeners[type];
        if (registered) {
            const index = registered.indexOf(callback);
            if (index >= 0) registered.splice(index, 1);
        }
    }
}


parcelRequire("cPdJo");
// definition for a point quadtree. Useful every now and again.. especially when working with 2D grids ;)
class $4811c2f0f662c58f$export$2e2bcd8739ae039 {
    constructor(minx, miny, maxx, maxy){
        this.minx = minx;
        this.miny = miny;
        this.maxx = maxx;
        this.maxy = maxy;
        this.midx = (this.minx + this.maxx) / 2;
        this.midy = (this.miny + this.maxy) / 2;
        this.bucket = [];
        this.nw = null;
        this.ne = null;
        this.sw = null;
        this.se = null;
    }
    insert(obj) {
        // first make sure that the object goes inside our region.
        if (obj.x < this.minx || obj.x >= this.maxx || obj.y < this.miny || obj.y >= this.maxy) return false;
        // if we have no children,
        if (!this.nw) {
            // if we have not filled our own bucket, add to it.
            if (this.bucket.length < 5) {
                this.bucket.push(obj);
                return true;
            }
            // if we fill our own bucket, split up.
            this.subdivide();
        }
        // try storing the object in one of our children.
        return this.nw.insert(obj) || this.ne.insert(obj) || this.sw.insert(obj) || this.se.insert(obj);
    }
    subdivide() {
        // split up into four quadrants (child nodes)
        this.nw = new $4811c2f0f662c58f$export$2e2bcd8739ae039(this.minx, this.miny, this.midx, this.midy);
        this.ne = new $4811c2f0f662c58f$export$2e2bcd8739ae039(this.midx, this.miny, this.maxx, this.midy);
        this.sw = new $4811c2f0f662c58f$export$2e2bcd8739ae039(this.minx, this.midy, this.midx, this.maxy);
        this.se = new $4811c2f0f662c58f$export$2e2bcd8739ae039(this.midx, this.midy, this.maxx, this.maxy);
        // dump the contents of our bucket into our children
        for(var i = 0; i < this.bucket.length; i++)this.insert(this.bucket[i]);
        this.bucket = null;
    }
    inRegion(minx, miny, maxx, maxy) {
        // check that we overlap with the region
        if (maxx < this.minx || minx >= this.maxx || maxy < this.miny || miny >= this.maxy) return [];
        // if we have no children, return our bucket.
        // I decided not to copy the bucket, for speed reasons.
        if (!this.nw) return this.bucket;
        var found = [];
        // push the contents of our children into the array and return it
        found = found.concat(this.nw.inRegion(minx, miny, maxx, maxy), this.ne.inRegion(minx, miny, maxx, maxy), this.sw.inRegion(minx, miny, maxx, maxy), this.se.inRegion(minx, miny, maxx, maxy));
        return found;
    }
    draw(canvas, ctx, minx, miny, maxx, maxy) {
        var midx = (minx + maxx) / 2;
        var midy = (miny + maxy) / 2;
        if (this.nw) {
            ctx.beginPath();
            ctx.moveTo(minx * canvas.drawWidth, midy * canvas.drawHeight);
            ctx.lineTo(maxx * canvas.drawWidth, midy * canvas.drawHeight);
            ctx.moveTo(midx * canvas.drawWidth, miny * canvas.drawHeight);
            ctx.lineTo(midx * canvas.drawWidth, maxy * canvas.drawHeight);
            ctx.closePath();
            ctx.strokeStyle = "#FF0000";
            ctx.stroke();
            this.nw.draw(canvas, ctx, minx, miny, midx, midy);
            this.ne.draw(canvas, ctx, midx, miny, maxx, midy);
            this.sw.draw(canvas, ctx, minx, midy, midx, maxy);
            this.se.draw(canvas, ctx, midx, midy, maxx, maxy);
        } else for(var i = 0; i < this.bucket.length; i++){
            var p = this.bucket[i];
            var x = minx + (p.x - this.minx) / (this.maxx - this.minx) * (maxx - minx);
            var y = miny + (p.y - this.miny) / (this.maxy - this.miny) * (maxy - miny);
            ctx.fillStyle = "#0000FF";
            ctx.fillRect(x * canvas.drawWidth, y * canvas.drawHeight, 1, 1);
        }
    }
}



class $dc7180c53067d938$export$6a4eb2e7fc9e8903 extends (0, $c2d7541b81dd5a64$export$2e2bcd8739ae039) {
    constructor(capacity){
        super();
        this.data = [];
        this.capacity = capacity;
    }
    map(transform, capacity = Infinity) {
        return this.mapAsync((x, cb)=>cb(transform(x)), null, capacity);
    }
    mapAsync(transform, abort, capacity = Infinity) {
        return this.pipe(new $dc7180c53067d938$var$Transformer(transform, abort, capacity));
    }
    filter(predicate, capacity = Infinity) {
        return this.filterAsync((x, cb)=>cb(predicate(x)), null, capacity);
    }
    filterAsync(predicate, abort, capacity = Infinity) {
        return this.pipe(new $dc7180c53067d938$var$Filter(predicate, abort, capacity));
    }
    forEach(callback) {
        const fill = ()=>{
            while(this.canRead())callback(this.read());
        };
        this.on("can-read", fill);
        fill();
    }
    pipe(dest) {
        const fill = ()=>{
            // TODO: Break this up if the streams have unlimited bandwidth
            while(this.canRead() && dest.canWrite())dest.write(this.read());
        };
        this.on("can-read", fill);
        dest.on("can-write", fill);
        this.on("clear", dest.clear.bind(dest));
        fill();
        return dest;
    }
    clear() {
        this.data = [];
        this.emit("clear");
    }
    canRead() {
        return this.data.length > 0;
    }
    read() {
        const res = this.data.shift();
        if (this.data.length === this.capacity - 1) {
            // This prevents infinite recursion when piping A=>B=>C
            //   where A and C have unlimited bandwidth and B has a capacity of 1:
            //   [can-write B]>(pipe A=>B)>[can-read B]>(pipe B=>C)>[can-write B]>...
            // If B has a capacity of greater than 1, this becomes:
            //   [can-write B]>(pipe A=>B)>[can-read B]>(pipe B=>C)
            //                            >[can-read B]>(pipe B=>C)
            //                            >...
            //   because writing from B does not cause its length to be (capacity-1),
            //   so the [can-write B] event does not get triggered during (pipe B=>C).
            // This delays the [can-write B] event if capacity === 1, so it becomes:
            //   [can-write B]>(pipe A=>B)>[can-read B]>(pipe B=>C)>[setTimeout]
            //   [can-write B]>(pipe A=>B)>[can-read B]>(pipe B=>C)>[setTimeout]
            //   ...
            // This will be slower, but hey, that's what you get ¯\_(ツ)_/¯
            if (this.capacity === 1) this.emitOnceAsync("can-write");
            else this.emit("can-write");
        }
        return res;
    }
    canWrite() {
        return this.data.length < this.capacity;
    }
    write(chunk) {
        if (this.canWrite()) {
            this.data.push(chunk);
            if (this.data.length === 1) this.emit("can-read");
        }
    }
}
class $dc7180c53067d938$var$Transformer extends $dc7180c53067d938$export$6a4eb2e7fc9e8903 {
    constructor(transform, abort, capacity){
        super(capacity);
        this.transform = transform;
        this.abort = abort;
        this.numReady = 0;
    }
    canRead() {
        return this.numReady > 0;
    }
    read() {
        this.numReady--;
        return super.read();
    }
    write(chunk) {
        super.write(chunk);
        this.transform(chunk, (data)=>{
            const index = this.data.indexOf(chunk);
            this.data.splice(index, 1);
            this.data.splice(this.numReady, 0, data);
            this.numReady++;
            if (this.numReady === 1) this.emit("can-read");
        });
    }
    clear() {
        if (this.abort) for(let i = this.numReady; i < this.data.length; i++)this.abort(this.data[i]);
        super.clear();
    }
}
class $dc7180c53067d938$var$Filter extends $dc7180c53067d938$export$6a4eb2e7fc9e8903 {
    constructor(predicate, abort, capacity){
        super(capacity);
        this.predicate = predicate;
        this.abort = abort;
    }
    write(chunk) {
        this.predicate(chunk, (x)=>x && super.write(chunk));
    }
    clear() {
        if (this.abort) this.data.forEach((data)=>this.abort(data));
        super.clear();
    }
}


function $c731a29915c32ed7$export$1391212d75b2ee65(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
function $c731a29915c32ed7$export$d02631cccf789723(from, to, step) {
    if (typeof to === "undefined") {
        to = from;
        from = 0;
    }
    if (typeof step === "undefined") step = Math.sign(to - from);
    if (step === 0) return [];
    const res = [];
    while(step > 0 ? to > from : to < from){
        res.push(from);
        from += step;
    }
    return res;
}


window.addEventListener("load", function() {
    const el = document.getElementById("minigame-toggle");
    el && new $a2cc34612ff9e900$var$ToggleGame(el);
});
class $a2cc34612ff9e900$var$ToggleGame {
    constructor(element, size = 8, difficulty = "medium", shape = "plus"){
        this.elements = {
            root: element,
            options: {},
            cells: []
        };
        this.size = size;
        this.board = [];
        this.isGaveOver = false;
        this.isResetting = false;
        this.difficulty = difficulty;
        this.shape = shape;
        for(var y = 0; y < size; y++){
            var row = [];
            for(var x = 0; x < size; x++)row[x] = false;
            this.board[y] = row;
        }
        this.init();
    }
    init() {
        /* eslint-disable max-len */ [
            /*#__PURE__*/ (0, $0ce5141a586bd8d5$export$4b938d075d59879c)("div", {
                className: "game-container",
                children: [
                    /*#__PURE__*/ (0, $0ce5141a586bd8d5$export$4b938d075d59879c)("table", {
                        children: (0, $c731a29915c32ed7$export$d02631cccf789723)(this.size).map((y)=>/*#__PURE__*/ (0, $0ce5141a586bd8d5$export$4b938d075d59879c)("tr", {
                                children: this.elements.cells[y] = (0, $c731a29915c32ed7$export$d02631cccf789723)(this.size).map((x)=>/*#__PURE__*/ (0, $0ce5141a586bd8d5$export$4b938d075d59879c)("td", {
                                        onclick: this.toggleAround.bind(this, x, y)
                                    }))
                            }))
                    }),
                    /*#__PURE__*/ (0, $0ce5141a586bd8d5$export$4b938d075d59879c)("div", {
                        className: "win-screen",
                        children: [
                            /*#__PURE__*/ (0, $0ce5141a586bd8d5$export$4b938d075d59879c)("div", {
                                className: "win-text",
                                children: "You Win!"
                            }),
                            /*#__PURE__*/ (0, $0ce5141a586bd8d5$export$4b938d075d59879c)("div", {
                                className: "reset-text",
                                children: "Play Again"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $0ce5141a586bd8d5$export$4b938d075d59879c)("div", {
                className: "text-container",
                children: [
                    /*#__PURE__*/ (0, $0ce5141a586bd8d5$export$4b938d075d59879c)("div", {
                        children: "Turn off all the cells!"
                    }),
                    /*#__PURE__*/ (0, $0ce5141a586bd8d5$export$4b938d075d59879c)("div", {
                        className: "hint",
                        children: "(It is possible, I promise)"
                    }),
                    /*#__PURE__*/ (0, $0ce5141a586bd8d5$export$4b938d075d59879c)("div", {
                        className: "fa fa-undo reset-btn",
                        onclick: this.reset.bind(this)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $0ce5141a586bd8d5$export$4b938d075d59879c)("div", {
                className: "options-container",
                children: [
                    /*#__PURE__*/ (0, $0ce5141a586bd8d5$export$4b938d075d59879c)("div", {
                        className: "options-row",
                        children: [
                            this.elements.options.difficultyEasy = /*#__PURE__*/ (0, $0ce5141a586bd8d5$export$4b938d075d59879c)("div", {
                                className: "option",
                                onclick: ()=>this.setDifficulty("easy"),
                                children: "Easy"
                            }),
                            this.elements.options.difficultyMedium = /*#__PURE__*/ (0, $0ce5141a586bd8d5$export$4b938d075d59879c)("div", {
                                className: "option",
                                onclick: ()=>this.setDifficulty("medium"),
                                children: "Medium"
                            }),
                            this.elements.options.difficultyHard = /*#__PURE__*/ (0, $0ce5141a586bd8d5$export$4b938d075d59879c)("div", {
                                className: "option",
                                onclick: ()=>this.setDifficulty("hard"),
                                children: "Hard"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $0ce5141a586bd8d5$export$4b938d075d59879c)("div", {
                        className: "options-row",
                        children: [
                            this.elements.options.shapePlus = /*#__PURE__*/ (0, $0ce5141a586bd8d5$export$4b938d075d59879c)("div", {
                                className: "option shape-plus",
                                onclick: ()=>this.setShape("plus"),
                                children: /*#__PURE__*/ (0, $0ce5141a586bd8d5$export$4b938d075d59879c)("span", {})
                            }),
                            this.elements.options.shapeDiamond = /*#__PURE__*/ (0, $0ce5141a586bd8d5$export$4b938d075d59879c)("div", {
                                className: "option shape-diamond",
                                onclick: ()=>this.setShape("diamond"),
                                children: /*#__PURE__*/ (0, $0ce5141a586bd8d5$export$4b938d075d59879c)("span", {})
                            }),
                            this.elements.options.shapeX = /*#__PURE__*/ (0, $0ce5141a586bd8d5$export$4b938d075d59879c)("div", {
                                className: "option shape-x",
                                onclick: ()=>this.setShape("x"),
                                children: /*#__PURE__*/ (0, $0ce5141a586bd8d5$export$4b938d075d59879c)("span", {})
                            }),
                            this.elements.options.shapeO = /*#__PURE__*/ (0, $0ce5141a586bd8d5$export$4b938d075d59879c)("div", {
                                className: "option shape-o",
                                onclick: ()=>this.setShape("o"),
                                children: /*#__PURE__*/ (0, $0ce5141a586bd8d5$export$4b938d075d59879c)("span", {})
                            })
                        ]
                    })
                ]
            })
        ].forEach((el)=>this.elements.root.appendChild(el));
        /* eslint-enable max-len */ this.setDifficulty(this.difficulty, false);
        this.setShape(this.shape, false);
        this.reset();
    }
    toggle(x, y, value, showUpdate = true) {
        if (x < 0 || y < 0 || x >= this.size || y >= this.size) return;
        var isLit = typeof value === "undefined" ? !this.board[y][x] : !!value;
        this.board[y][x] = isLit;
        if (showUpdate) this.updateClass(x, y, isLit);
    }
    toggleAround(x, y, showUpdate) {
        switch(this.shape){
            default:
            case "plus":
                this.toggle(x, y, undefined, showUpdate);
                this.toggle(x + 1, y, undefined, showUpdate);
                this.toggle(x - 1, y, undefined, showUpdate);
                this.toggle(x, y + 1, undefined, showUpdate);
                this.toggle(x, y - 1, undefined, showUpdate);
                break;
            case "diamond":
                this.toggle(x + 1, y, undefined, showUpdate);
                this.toggle(x - 1, y, undefined, showUpdate);
                this.toggle(x, y + 1, undefined, showUpdate);
                this.toggle(x, y - 1, undefined, showUpdate);
                break;
            case "x":
                this.toggle(x, y, undefined, showUpdate);
                this.toggle(x + 1, y + 1, undefined, showUpdate);
                this.toggle(x - 1, y + 1, undefined, showUpdate);
                this.toggle(x + 1, y - 1, undefined, showUpdate);
                this.toggle(x - 1, y - 1, undefined, showUpdate);
                break;
            case "o":
                this.toggle(x, y + 1, undefined, showUpdate);
                this.toggle(x + 1, y + 1, undefined, showUpdate);
                this.toggle(x + 1, y, undefined, showUpdate);
                this.toggle(x + 1, y - 1, undefined, showUpdate);
                this.toggle(x, y - 1, undefined, showUpdate);
                this.toggle(x - 1, y - 1, undefined, showUpdate);
                this.toggle(x - 1, y, undefined, showUpdate);
                this.toggle(x - 1, y + 1, undefined, showUpdate);
                break;
        }
        if (!this.isGameOver && !this.isResetting) this.checkForWin();
    }
    updateClass(x, y, isLit) {
        if (typeof isLit === "undefined") isLit = this.board[y][x];
        this.elements.cells[y][x].className = isLit ? "active" : "";
    }
    updateClasses(animate) {
        if (animate) {
            for(let y = 0; y < this.size; y++)for(let x = 0; x < this.size; x++)setTimeout(this.updateClass.bind(this, x, y, this.board[y][x]), (x + y) * 25);
        } else {
            for(let y = 0; y < this.size; y++)for(let x = 0; x < this.size; x++)this.updateClass(x, y);
        }
    }
    checkForWin() {
        for(var y = 0; y < this.size; y++)for(var x = 0; x < this.size; x++){
            if (this.board[y][x]) return;
        }
        if (this.isGameOver || this.isResetting) return;
        this.isGameOver = true;
        this.elements.root.className = "game-over";
    }
    setShape(shape, reset = true) {
        this.shape = shape;
        this.elements.options.shapePlus.className = shape === "plus" ? "option shape-plus active" : "option shape-plus";
        this.elements.options.shapeDiamond.className = shape === "diamond" ? "option shape-diamond active" : "option shape-diamond";
        this.elements.options.shapeX.className = shape === "x" ? "option shape-x active" : "option shape-x";
        this.elements.options.shapeO.className = shape === "o" ? "option shape-o active" : "option shape-o";
        if (reset) this.reset();
    }
    setDifficulty(difficulty, reset = true) {
        this.difficulty = difficulty;
        this.elements.options.difficultyEasy.className = difficulty === "easy" ? "option active" : "option";
        this.elements.options.difficultyMedium.className = difficulty === "medium" ? "option active" : "option";
        this.elements.options.difficultyHard.className = difficulty === "hard" ? "option active" : "option";
        if (reset) this.reset();
    }
    async reset() {
        var wasGameOver = this.isGameOver;
        this.elements.root.className = "";
        this.isGameOver = false;
        if (this.isResetting) return;
        this.isResetting = true;
        for(let y = 0; y < this.size; y++)for(let x = 0; x < this.size; x++)this.toggle(x, y, false, wasGameOver);
        if (!wasGameOver) {
            this.updateClasses(true);
            await (0, $c731a29915c32ed7$export$1391212d75b2ee65)(250);
        }
        var numToggles;
        switch(this.difficulty){
            default:
            case "easy":
                numToggles = this.size * this.size * 0.1;
                break;
            case "medium":
                numToggles = this.size * this.size * 0.25;
                break;
            case "hard":
                numToggles = this.size * this.size * 0.5;
                break;
        }
        for(var i = 0; i < numToggles; i++){
            let x = Math.floor(Math.random() * this.size);
            let y = Math.floor(Math.random() * this.size);
            this.toggleAround(x, y, false);
        }
        this.updateClasses(true);
        this.isResetting = false;
    }
}




const $7b947d6482b2ba2c$export$6c80b9756624912 = 0.7;
const $7b947d6482b2ba2c$export$2a350b7b67a021c7 = $7b947d6482b2ba2c$export$6c80b9756624912 / 2;
const $7b947d6482b2ba2c$export$8662d5a33c179c01 = 1;
const $7b947d6482b2ba2c$export$b65795264973d9e = $7b947d6482b2ba2c$export$8662d5a33c179c01 / 2;
function $7b947d6482b2ba2c$export$a4e74f3c8fbac4f2(context, x, y, radius) {
    context.beginPath();
    context.arc(x, y, radius, 0, 2 * Math.PI);
    context.fill();
}
function $7b947d6482b2ba2c$export$895c5e634403eaa7(a, b, grow) {
    return {
        minX: Math.min(a.x, b.x) - grow,
        minY: Math.min(a.y, b.y) - grow,
        maxX: Math.max(a.x, b.x) + grow,
        maxY: Math.max(a.y, b.y) + grow
    };
}
function $7b947d6482b2ba2c$export$671647aed1cefc41(start, direction, grow, min, len) {
    const a = {
        x: start.x + direction.x * min,
        y: start.y + direction.y * min
    };
    const b = {
        x: start.x + direction.x * (min + len),
        y: start.y + direction.y * (min + len)
    };
    return {
        minX: Math.min(a.x, b.x) - grow * Math.abs(direction.y),
        minY: Math.min(a.y, b.y) - grow * Math.abs(direction.x),
        maxX: Math.max(a.x, b.x) + grow * Math.abs(direction.y),
        maxY: Math.max(a.y, b.y) + grow * Math.abs(direction.x)
    };
}
function $7b947d6482b2ba2c$export$73ea0f5437760b7b(a, b) {
    return a.maxX > b.minX && a.minX < b.maxX && a.maxY > b.minY && a.minY < b.maxY;
}
function $7b947d6482b2ba2c$export$9a74f4c8e3152081(dx, dy) {
    if (Math.abs(dx) > Math.abs(dy)) return {
        x: Math.sign(dx) || 1,
        y: 0
    };
    else return {
        x: 0,
        y: Math.sign(dy) || 1
    };
}
function $7b947d6482b2ba2c$export$9fc9dd311300f9ff(canvas, context) {
    const res = window.devicePixelRatio || 1;
    canvas.style.width = canvas.width + "px";
    canvas.style.height = canvas.height + "px";
    canvas.width *= res;
    canvas.height *= res;
    context.scale(res, res);
}
function $7b947d6482b2ba2c$export$566a610b2b1ce2(obj, member) {
    return obj[member];
}


const $abda2f90acb05382$var$DEFAULT_SPEED = 7.5;
const $abda2f90acb05382$var$DEFAULT_LENGTH = 2;
class $abda2f90acb05382$export$2e2bcd8739ae039 {
    constructor(x, y, dx, dy){
        this.reset(x, y, dx, dy);
    }
    reset(x, y, dx, dy) {
        this.segments = [
            {
                x: x,
                y: y
            },
            {
                x: x,
                y: y
            }
        ];
        this.direction = {
            x: dx,
            y: dy
        };
        this.speed = $abda2f90acb05382$var$DEFAULT_SPEED;
        this.foodEaten = 0;
        this.moveStun = 0;
        this.chaseStun = $abda2f90acb05382$var$DEFAULT_LENGTH;
    }
    update(dt) {
        this.move(dt * this.speed);
        this.chase(dt * this.speed);
    }
    eat() {
        this.foodEaten++;
        this.speed += 0.1;
        this.chaseStun += 2;
    }
    getHead(dt) {
        const head = this.segments[this.segments.length - 1];
        if (dt) return {
            x: head.x + this.direction.x * this.speed * dt,
            y: head.y + this.direction.y * this.speed * dt
        };
        return head;
    }
    setDirection(dir) {
        if (dir.x === this.direction.x && dir.y === this.direction.y) return;
        if (dir.x === -this.direction.x && dir.y === -this.direction.y) return;
        const head = this.getHead();
        this.segments.push({
            x: head.x,
            y: head.y
        });
        this.direction = dir;
    }
    willEatSelf(lookaheadTime) {
        const head = this.getHead();
        const dist = lookaheadTime * this.speed;
        const front = (0, $7b947d6482b2ba2c$export$671647aed1cefc41)(head, this.direction, (0, $7b947d6482b2ba2c$export$2a350b7b67a021c7), (0, $7b947d6482b2ba2c$export$2a350b7b67a021c7) * 1.01, dist);
        for(let i = this.segments.length - 3; i >= 0; i--){
            const bb = (0, $7b947d6482b2ba2c$export$895c5e634403eaa7)(this.segments[i + 1], this.segments[i], (0, $7b947d6482b2ba2c$export$2a350b7b67a021c7));
            if ((0, $7b947d6482b2ba2c$export$73ea0f5437760b7b)(front, bb)) return true;
        }
        return false;
    }
    draw(context) {
        const head = this.getHead();
        const ax = this.direction.x;
        const ay = this.direction.y;
        // body
        context.strokeStyle = "#009688";
        context.lineWidth = (0, $7b947d6482b2ba2c$export$6c80b9756624912);
        context.beginPath();
        context.moveTo(head.x, head.y);
        for(let i = this.segments.length - 2; i >= 0; i--)context.lineTo(this.segments[i].x, this.segments[i].y);
        context.stroke();
        context.strokeStyle = "#00897B";
        context.lineWidth = (0, $7b947d6482b2ba2c$export$6c80b9756624912) * 0.9;
        context.setLineDash([
            0,
            0.99
        ]);
        context.beginPath();
        context.moveTo(head.x, head.y);
        for(let i = this.segments.length - 2; i >= 0; i--)context.lineTo(this.segments[i].x, this.segments[i].y);
        context.stroke();
        context.setLineDash([]);
        // for head features, transform relative to the head
        context.save();
        context.translate(head.x, head.y);
        context.rotate(ax ? Math.PI * (ax - 1) / 2 : Math.PI * ay / 2);
        // tongue
        context.strokeStyle = "#f44336";
        context.lineWidth = 0.1;
        context.beginPath();
        context.moveTo(0.35, 0);
        context.arcTo(0.4, 0.05, 0.45, 0, 0.07);
        context.arcTo(0.5, -0.05, 0.55, 0, 0.07);
        context.stroke();
        context.fillStyle = "#00897B";
        (0, $7b947d6482b2ba2c$export$a4e74f3c8fbac4f2)(context, 0, 0, (0, $7b947d6482b2ba2c$export$2a350b7b67a021c7));
        // eyes
        context.fillStyle = "white";
        (0, $7b947d6482b2ba2c$export$a4e74f3c8fbac4f2)(context, 0, (0, $7b947d6482b2ba2c$export$6c80b9756624912) * 0.25, (0, $7b947d6482b2ba2c$export$6c80b9756624912) * 0.2);
        (0, $7b947d6482b2ba2c$export$a4e74f3c8fbac4f2)(context, 0, (0, $7b947d6482b2ba2c$export$6c80b9756624912) * -0.25, (0, $7b947d6482b2ba2c$export$6c80b9756624912) * 0.2);
        context.fillStyle = "black";
        (0, $7b947d6482b2ba2c$export$a4e74f3c8fbac4f2)(context, (0, $7b947d6482b2ba2c$export$6c80b9756624912) * 0.1, (0, $7b947d6482b2ba2c$export$6c80b9756624912) * 0.23, (0, $7b947d6482b2ba2c$export$6c80b9756624912) * 0.1);
        (0, $7b947d6482b2ba2c$export$a4e74f3c8fbac4f2)(context, (0, $7b947d6482b2ba2c$export$6c80b9756624912) * 0.1, (0, $7b947d6482b2ba2c$export$6c80b9756624912) * -0.23, (0, $7b947d6482b2ba2c$export$6c80b9756624912) * 0.1);
        context.restore();
    }
    move(dist) {
        const x = Math.min(this.moveStun, dist);
        this.moveStun -= x;
        dist -= x;
        if (dist <= 0) return;
        if (this.moveStun > 0) return;
        const head = this.getHead();
        head.x += this.direction.x * dist;
        head.y += this.direction.y * dist;
    }
    chase(dist) {
        const x = Math.min(this.chaseStun, dist);
        this.chaseStun -= x;
        dist -= x;
        if (dist <= 0) return;
        if (this.chaseStun > 0) return;
        if (this.segments.length < 2) return; // TODO: game over
        const from = this.segments[0];
        const to = this.segments[1];
        const dx = to.x - from.x;
        const dy = to.y - from.y;
        // one of dx or dy should always be 0, so no need for Euclidean dist
        const d = Math.abs(dx) + Math.abs(dy);
        if (dist >= d) {
            this.segments.shift();
            this.chase(dist - d);
        } else {
            from.x += dist * dx / d;
            from.y += dist * dy / d;
        }
    }
}



class $b73e993a64ca8ca1$export$2e2bcd8739ae039 {
    constructor(x, y){
        this.move(x, y);
    }
    move(x, y) {
        this.position = {
            x: x,
            y: y
        };
    }
    draw(context) {
        const pos = this.position;
        context.fillStyle = "#f44336";
        (0, $7b947d6482b2ba2c$export$a4e74f3c8fbac4f2)(context, pos.x, pos.y, (0, $7b947d6482b2ba2c$export$b65795264973d9e));
        context.fillStyle = "#00897B";
        context.beginPath();
        context.moveTo(pos.x, pos.y - 0.3);
        context.arcTo(pos.x, pos.y - (0, $7b947d6482b2ba2c$export$8662d5a33c179c01) * 0.8, pos.x + (0, $7b947d6482b2ba2c$export$8662d5a33c179c01) * 0.5, pos.y - (0, $7b947d6482b2ba2c$export$8662d5a33c179c01) * 0.7, (0, $7b947d6482b2ba2c$export$8662d5a33c179c01) * 0.5);
        context.arcTo(pos.x + (0, $7b947d6482b2ba2c$export$8662d5a33c179c01) * 0.5, pos.y - (0, $7b947d6482b2ba2c$export$8662d5a33c179c01) * 0.3, pos.x, pos.y - (0, $7b947d6482b2ba2c$export$8662d5a33c179c01) * 0.3, (0, $7b947d6482b2ba2c$export$8662d5a33c179c01) * 0.5);
        context.fill();
    }
}




const $318020f4cfb77f79$var$GAME_SCALE = 14;
class $318020f4cfb77f79$export$2e2bcd8739ae039 extends (0, $c2d7541b81dd5a64$export$2e2bcd8739ae039) {
    constructor(size){
        super();
        this.size = size;
        this.snake = new (0, $abda2f90acb05382$export$2e2bcd8739ae039)(0, 0, 0, 0);
        this.food = new (0, $b73e993a64ca8ca1$export$2e2bcd8739ae039)(0, 0);
        this.canvas = /*#__PURE__*/ (0, $0ce5141a586bd8d5$export$4b938d075d59879c)("canvas", {
            width: size * $318020f4cfb77f79$var$GAME_SCALE,
            height: size * $318020f4cfb77f79$var$GAME_SCALE,
            tabIndex: 0
        });
        this.context = this.canvas.getContext("2d");
        this.centerTouch = null;
        (0, $7b947d6482b2ba2c$export$9fc9dd311300f9ff)(this.canvas, this.context);
        this.context.lineJoin = "round";
        this.context.lineCap = "round";
        this.context.scale($318020f4cfb77f79$var$GAME_SCALE, $318020f4cfb77f79$var$GAME_SCALE);
        this.addListeners();
    }
    reset() {
        const x = Math.random() * (this.size - (0, $7b947d6482b2ba2c$export$6c80b9756624912)) + (0, $7b947d6482b2ba2c$export$2a350b7b67a021c7);
        const y = Math.random() * (this.size - (0, $7b947d6482b2ba2c$export$6c80b9756624912)) + (0, $7b947d6482b2ba2c$export$2a350b7b67a021c7);
        const dir = (0, $7b947d6482b2ba2c$export$9a74f4c8e3152081)(this.size / 2 - x, this.size / 2 - y);
        this.snake.reset(x, y, dir.x, dir.y);
        this.placeFood();
    }
    update(dt) {
        const willDie = this.checkForDeath(dt);
        this.snake.update(dt);
        if (willDie) this.emit("die", this.snake.foodEaten);
        else this.tryEat();
        this.draw();
    }
    draw() {
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.snake.draw(this.context);
        this.food.draw(this.context);
    }
    tryEat() {
        const head = this.snake.getHead();
        const dx = head.x - this.food.position.x;
        const dy = head.y - this.food.position.y;
        const DIST = (0, $7b947d6482b2ba2c$export$b65795264973d9e) + (0, $7b947d6482b2ba2c$export$2a350b7b67a021c7);
        if (dx * dx + dy * dy < DIST * DIST) {
            this.snake.eat();
            this.placeFood();
            this.emit("eat", this.snake.foodEaten);
        }
    }
    checkForDeath(dt) {
        const head = this.snake.getHead(dt);
        const hitWall = head.x < (0, $7b947d6482b2ba2c$export$2a350b7b67a021c7) || head.x > this.size - (0, $7b947d6482b2ba2c$export$2a350b7b67a021c7) || head.y < (0, $7b947d6482b2ba2c$export$2a350b7b67a021c7) || head.y > this.size - (0, $7b947d6482b2ba2c$export$2a350b7b67a021c7);
        return hitWall || this.snake.willEatSelf(dt);
    }
    placeFood() {
        const x = Math.random() * (this.size - (0, $7b947d6482b2ba2c$export$8662d5a33c179c01)) + (0, $7b947d6482b2ba2c$export$b65795264973d9e);
        const y = Math.random() * (this.size - (0, $7b947d6482b2ba2c$export$8662d5a33c179c01)) + (0, $7b947d6482b2ba2c$export$b65795264973d9e);
        this.food.move(x, y);
    }
    addListeners() {
        this.canvas.addEventListener("keydown", (event)=>{
            event.preventDefault();
            switch(event.keyCode){
                case 65:
                case 37:
                    return this.snake.setDirection({
                        x: -1,
                        y: 0
                    }); // left
                case 87:
                case 38:
                    return this.snake.setDirection({
                        x: 0,
                        y: -1
                    }); // up
                case 68:
                case 39:
                    return this.snake.setDirection({
                        x: 1,
                        y: 0
                    }); // right
                case 83:
                case 40:
                    return this.snake.setDirection({
                        x: 0,
                        y: 1
                    }); // down
            }
        });
        this.canvas.addEventListener("touchstart", (event)=>{
            if (!this.centerTouch) {
                event.preventDefault();
                this.centerTouch = event.changedTouches[0];
            }
        });
        this.canvas.addEventListener("touchmove", (event)=>{
            if (this.centerTouch) for(let i = 0; i < event.changedTouches.length; i++){
                const touch = event.changedTouches[i];
                if (touch.identifier === this.centerTouch.identifier) {
                    event.preventDefault();
                    const dx = touch.clientX - this.centerTouch.clientX;
                    const dy = touch.clientY - this.centerTouch.clientY;
                    if (Math.abs(dx) > 20 || Math.abs(dy) > 20) {
                        const dir = (0, $7b947d6482b2ba2c$export$9a74f4c8e3152081)(dx, dy);
                        this.snake.setDirection(dir);
                    }
                    break;
                }
            }
        });
        this.canvas.addEventListener("touchend", (event)=>{
            if (this.centerTouch) for(let i = 0; i < event.changedTouches.length; i++){
                const touch = event.changedTouches[i];
                if (touch.identifier === this.centerTouch.identifier) {
                    event.preventDefault();
                    this.centerTouch = null;
                    break;
                }
            }
        });
    }
}



const $29257819aa9fe03b$var$TYPE_WALL = 0;
const $29257819aa9fe03b$var$TYPE_SNAKE = 1;
class $29257819aa9fe03b$export$2e2bcd8739ae039 {
    constructor(field){
        this.field = field;
        this.snake = (0, $7b947d6482b2ba2c$export$566a610b2b1ce2)(field, "snake");
        this.food = (0, $7b947d6482b2ba2c$export$566a610b2b1ce2)(field, "food");
    }
    consult() {
        const head = this.snake.getHead();
        const direction = (0, $7b947d6482b2ba2c$export$566a610b2b1ce2)(this.snake, "direction");
        let dir, needToTurn = true;
        const dx = this.food.position.x - head.x;
        const dy = this.food.position.y - head.y;
        const f = dx * direction.x + dy * direction.y;
        // first try going for food
        if (f < (0, $7b947d6482b2ba2c$export$6c80b9756624912) / 4 && (Math.abs(dx) > (0, $7b947d6482b2ba2c$export$6c80b9756624912) || Math.abs(dy) > (0, $7b947d6482b2ba2c$export$6c80b9756624912))) {
            dir = {
                x: Math.abs(direction.y) * Math.sign(dx),
                y: Math.abs(direction.x) * Math.sign(dy)
            };
            needToTurn = this.avoid(dir, true);
        }
        // then default to just going straight
        if (needToTurn) {
            dir = direction;
            needToTurn = this.avoid(dir, false, false);
        }
        // if we need to turn, pick a random direction
        if (needToTurn) {
            dir = {
                x: direction.y * Math.sign(Math.random() - 0.5),
                y: direction.x * Math.sign(Math.random() - 0.5)
            };
            needToTurn = this.avoid(dir);
        }
        // if the previous direction didn't work, turn around
        if (needToTurn) {
            dir = {
                x: -dir.x,
                y: -dir.y
            };
            needToTurn = this.avoid(dir);
        }
        this.snake.setDirection(dir);
    }
    findNearestObstacle(dir) {
        const head = this.snake.getHead();
        const segments = (0, $7b947d6482b2ba2c$export$566a610b2b1ce2)(this.snake, "segments");
        const searchBB = (0, $7b947d6482b2ba2c$export$671647aed1cefc41)(head, dir, (0, $7b947d6482b2ba2c$export$2a350b7b67a021c7), (0, $7b947d6482b2ba2c$export$2a350b7b67a021c7) * 1.01, 10000);
        let minObstacle = null;
        for(let i = segments.length - 2; i >= 0; i--){
            const targetBB = (0, $7b947d6482b2ba2c$export$895c5e634403eaa7)(segments[i + 1], segments[i], (0, $7b947d6482b2ba2c$export$2a350b7b67a021c7));
            if ((0, $7b947d6482b2ba2c$export$73ea0f5437760b7b)(targetBB, searchBB)) {
                const dist = Math.max(Math.min(dir.x * (targetBB.minX - head.x), dir.x * (targetBB.maxX - head.x)), Math.min(dir.y * (targetBB.minY - head.y), dir.y * (targetBB.maxY - head.y))) - (0, $7b947d6482b2ba2c$export$2a350b7b67a021c7);
                if (!minObstacle || minObstacle.dist > dist) minObstacle = {
                    type: $29257819aa9fe03b$var$TYPE_SNAKE,
                    dist: dist
                };
            }
        }
        if (minObstacle) return minObstacle;
        const size = (0, $7b947d6482b2ba2c$export$566a610b2b1ce2)(this.field, "size");
        return {
            type: $29257819aa9fe03b$var$TYPE_WALL,
            dist: Math.max(dir.x * (size - (0, $7b947d6482b2ba2c$export$2a350b7b67a021c7) - head.x), dir.x * ((0, $7b947d6482b2ba2c$export$2a350b7b67a021c7) - head.x), dir.y * (size - (0, $7b947d6482b2ba2c$export$2a350b7b67a021c7) - head.y), dir.y * ((0, $7b947d6482b2ba2c$export$2a350b7b67a021c7) - head.y))
        };
    }
    avoid(dir, goingForFood = false, turning = true) {
        const obstacle = this.findNearestObstacle(dir);
        const eaten = (0, $7b947d6482b2ba2c$export$566a610b2b1ce2)(this.snake, "foodEaten");
        return obstacle.type === $29257819aa9fe03b$var$TYPE_SNAKE && goingForFood ? obstacle.dist < (0, $7b947d6482b2ba2c$export$6c80b9756624912) * 2 * Math.sqrt(eaten + 1) : turning ? obstacle.dist < (0, $7b947d6482b2ba2c$export$6c80b9756624912) + 0.2 : obstacle.dist < 0.2;
    }
}


window.addEventListener("load", function() {
    const el = document.getElementById("minigame-snake");
    el && new $093e2de8f42eca34$var$SnakeGame(el);
});
class $093e2de8f42eca34$var$SnakeGame {
    constructor(root, size = 20){
        this.field = new (0, $318020f4cfb77f79$export$2e2bcd8739ae039)(size);
        this.ai = new (0, $29257819aa9fe03b$export$2e2bcd8739ae039)(this.field);
        this.lastUpdateTime = 0;
        this.isPaused = false;
        this.userPlaying = false;
        this.pause = this.pause.bind(this);
        this.resume = this.resume.bind(this);
        this.update = this.update.bind(this);
        this.setScore = this.setScore.bind(this);
        this.gameOver = this.gameOver.bind(this);
        [
            /*#__PURE__*/ (0, $0ce5141a586bd8d5$export$4b938d075d59879c)("div", {
                className: "game-container",
                children: [
                    this.canvas = this.field.canvas,
                    /*#__PURE__*/ (0, $0ce5141a586bd8d5$export$4b938d075d59879c)("div", {
                        className: "score",
                        children: [
                            /*#__PURE__*/ (0, $0ce5141a586bd8d5$export$4b938d075d59879c)("span", {
                                children: "Score: "
                            }),
                            this.scoreEl = /*#__PURE__*/ (0, $0ce5141a586bd8d5$export$4b938d075d59879c)("span", {
                                children: "0"
                            })
                        ]
                    }),
                    this.overlay = /*#__PURE__*/ (0, $0ce5141a586bd8d5$export$4b938d075d59879c)("div", {
                        className: "overlay",
                        children: "Click to Play"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $0ce5141a586bd8d5$export$4b938d075d59879c)("div", {
                className: "info",
                children: "Use W,A,S,D / arrow keys / swipe to turn"
            })
        ].forEach((el)=>root.appendChild(el));
        this.canvas.addEventListener("focus", this.resume);
        this.canvas.addEventListener("blur", this.pause);
        this.canvas.addEventListener("touchstart", this.resume);
        this.field.on("eat", this.setScore);
        this.field.on("die", this.gameOver);
        this.showOverlay("Click to Play");
        this.reset();
        this.update();
    }
    reset() {
        this.field.reset();
        this.scoreEl.textContent = "0";
        this.lastUpdateTime = +new Date();
    }
    update() {
        const time = +new Date();
        const dt = (time - this.lastUpdateTime) / 1000;
        this.lastUpdateTime = time;
        if (!this.userPlaying) this.ai.consult();
        this.field.update(dt);
        if (!this.isPaused) window.requestAnimationFrame(this.update);
    }
    gameOver(score) {
        if (this.userPlaying) {
            this.pause();
            this.showOverlay("<span>You scored " + score + " points</span>" + "<span>Click to play again</span>");
            this.userPlaying = false;
            this.canvas.blur();
        } else this.reset();
    }
    setScore(score) {
        this.scoreEl.textContent = "" + score;
    }
    pause() {
        if (this.userPlaying) {
            this.showOverlay("Click to Resume");
            this.isPaused = true;
        }
    }
    resume() {
        this.hideOverlay();
        if (!this.userPlaying) {
            this.userPlaying = true;
            this.reset();
        }
        if (this.isPaused) {
            this.isPaused = false;
            this.lastUpdateTime = +new Date();
            this.update();
        }
    }
    showOverlay(content) {
        this.overlay.style.display = "";
        this.overlay.innerHTML = content;
        this.canvas.style.opacity = "0.5";
    }
    hideOverlay() {
        this.overlay.style.display = "none";
        this.canvas.style.opacity = "1";
    }
}






//# sourceMappingURL=404.980e0978.js.map
